import { Checkbox, type CheckboxProps } from '@progress/kendo-react-inputs'
import React from 'react'
import { useFormContext } from 'react-hook-form'
import * as R from 'remeda'

import { type InputValues } from './utils'

export const AllCheckbox = () => {
  const { setValue, trigger, watch } = useFormContext<InputValues>()

  const customerAttributes = watch('customerAttributes')
  const isAllChecked = customerAttributes.every(R.prop('checked'))
    ? true
    : customerAttributes.every(R.isNot(R.prop('checked')))
      ? false
      : null

  const handleAllChange = React.useCallback<EH<CheckboxProps, 'onChange'>>(
    (event) => {
      setValue(
        'customerAttributes',
        customerAttributes.map(R.set('checked', event.value)),
      )
      trigger('customerAttributes')
    },
    [customerAttributes, setValue, trigger],
  )

  return <Checkbox checked={isAllChecked} onChange={handleAllChange} />
}
